import Spinner from '../Spinner/Spinner'

const withSpinner = (WrapedComponent) => ({ isLoading, ...others }) => {
    return (isLoading ? <Spinner></Spinner>
        : <WrapedComponent {...others} ></WrapedComponent >)
}

export default withSpinner